import React from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { translate } from "react-translate";
import KitsList from 'components/Kits/KitsList';

const Kits = (props) => {
  const {t} = props;
  
  return (
    <div className='content user-manual'>
      <Card>
        <CardHeader>
          <h5 className="title">{t("title-header")}</h5>
        </CardHeader>
        <CardBody>
          <KitsList />
        </CardBody>
      </Card>
    </div>
  );
};

export default translate("kits")(Kits);
